<template>
  <div class="card shadow mt-2 mb-3 border-0" v-if="alert">
    <div class="row p-3">
      <h5>Уведомления</h5>
      <div class="sub-title">Подписка на уведомления</div>
      <div class="alert-settings">

        <div class="title">

          <div class="checkbox ms-auto">
            <input id="email_alert" v-model="alert.email" type="checkbox" value="1">
            <label class="text-white" for="email_alert"></label>
          </div>
          <div>
            <strong> Email уведомления</strong><br>
            <div class="sub-title">Для уведомлений можно указать отличный от основного email  в <a href="/profile_settings">настройках
              пользователя</a></div>
          </div>
        </div>
        <div class="title">

          <div class="checkbox ms-auto">
            <input id="weekly_alert" type="checkbox" v-model="alert.tg" value="1">
            <label class="text-white" for="weekly_alert"></label>
          </div>
          <div>
            <strong> Уведомления в Telegram</strong><br>
            <div class="sub-title">Для работы требуется подключение в <a href="/profile_settings">настройках
              пользователя</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row p-3 pt-0" v-if="alert.tg || alert.email">
      <div class="col">
        <h5 class="title">
          Типы уведомлений
        </h5>
        <div class="notify-types">
          <div v-for="type in alert.notify_types" :key="type.key" class="checkbox">
            <input
                :id="type.key"
                type="checkbox"
                :value="type.key"
                :checked="isTypeChecked(type.key)"
                @change="onTypeChange(type.key, $event)"
            >
            <label :for="type.key">{{ type.name }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="row p-3">
      <div class="col">
        <button @click="saveSetting" class="btn btn-primary btn-success">Сохранить</button>
      </div>


    </div>
  </div>

</template>

<script>


import {ProjectApi} from "@/api/projects";

export default {
  name: 'ProjectAlertSettings',
  components: {},
  props: {},
  data() {
    return {
      alert: null,
    }

  },

  mounted: function () {
    ProjectApi.get_alert_settings(this.$store.getters.currentProjectId).then(resp => {
      this.alert = resp
    })
  },
  computed: {},

  methods: {
    saveSetting() {
      ProjectApi.save_alert_settings(this.$store.getters.currentProjectId, this.alert).then(resp => {
        this.alert = resp
        this.$notify({
          type: "success",
          text: 'Сохранено'
        })
      })
    },

    isTypeChecked(key) {
      if (!this.alert.settings) {
        this.alert.settings = []
      }
      const idx = this.alert.settings.indexOf(key)
      return idx >= 0;
    },

    onTypeChange(key, event) {
      // const checked = event.target.checked;
      if (!this.alert.settings) {
        this.alert.settings = []
      }
      const idx = this.alert.settings.indexOf(key);
      if (idx < 0) {
        this.alert.settings.push(key);
      } else {
        this.alert.settings.splice(idx, 1);
      }
    },

  }
}

</script>
<style scoped lang="scss">
.alert-settings {
  display: flex;
  gap: 15px;
  padding: 10px 26px;
}

button {
  width: 150px;
}

.notify-types {
  column-count: 2;

  .checkbox {
    padding-bottom: 10px;
  }
}
</style>

